export const MAX_RESEND_COUNT = 5;
export const MAX_RESEND_ERROR_MESSAGE = 'Reached max resend attempts.';
